import groupBy from 'nightwatch-web/utils/group-by';
import FilterAreaComponent from 'nightwatch-web/components/filters/filter-area';
import { A } from '@ember/array';

export default FilterAreaComponent.extend({
  checksByCategory: groupBy('checks', 'category'),
  availableCategories: A(['warning', 'problematic']),
});
